<template>
  <v-container fluid class="revert-page">
    <!-- Alert -->
    <AAlertBanner :messages="alertError" hide-title />

    <!-- Revert Form Confirm Dialog -->
    <v-dialog v-model="revertFormDialog" max-width="460" content-class="revert-confirm-dialog">
      <div class="revert-confirm-card">
        <h3 class="revert-confirm-card__title">{{ submitProperties.text }}</h3>
        <p class="revert-confirm-card__message">{{ submitProperties.msg }}</p>
        <div class="revert-confirm-card__actions">
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--cancel"
            @click="revertFormDialog = false"
          >
            Cancel
          </button>
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--confirm"
            :disabled="apiSubmit.isLoading"
            @click="modalRevertForm()"
          >
            Submit
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Revert Case Confirm Dialog -->
    <v-dialog v-model="revertCaseDialog" max-width="460" content-class="revert-confirm-dialog">
      <div class="revert-confirm-card">
        <h3 class="revert-confirm-card__title">Revert Case Back To Tab 3.0</h3>
        <p class="revert-confirm-card__message">Are you sure to revert this case?</p>
        <div class="revert-confirm-card__actions">
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--cancel"
            @click="revertCaseDialog = false"
          >
            Cancel
          </button>
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--danger"
            @click="revertCase()"
          >
            Revert
          </button>
        </div>
      </div>
    </v-dialog>

    <TrainingDaysListingComponent
      v-if="isHrdcAdminRoles"
      :datas="staticTaxpodData"
    ></TrainingDaysListingComponent>

    <!-- Header -->
    <div class="revert-header">
      <div class="revert-header__top">

        <div v-if="!loadingDialog" class="revert-header__info">
          <h1 class="revert-header__title">
            {{ model.add.name }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="revert-header__info-icon">
                  mdi-information-slab-circle
                </v-icon>
              </template>
              2 Complete Form + Grant Approval No. consider as complete form
            </v-tooltip>
          </h1>
        </div>

        <div class="revert-header__actions">
          <span v-if="isHrdcAdminRoles && displayRevertBtn">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="hero-action-btn hero-action-btn--amber"
                  :disabled="apiRevertCase.isLoading"
                  @click="revertCaseDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                  </svg>
                </button>
              </template>
              <span>
                Revert Case
                <br />
                (Back to send Tab 3.0)
              </span>
            </v-tooltip>
          </span>

          <span v-if="isHrdcAdminRoles && !btnDisabled">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="hero-action-btn hero-action-btn--green"
                  :disabled="apiSubmit.isLoading"
                  @click="revertFormDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="18">mdi-check-circle-outline</v-icon>
                </button>
              </template>
              <span>Submit</span>
            </v-tooltip>
          </span>
        </div>
      </div>
    </div>

    <!-- Application Details Section -->
    <div class="section-card" style="margin-bottom: 24px;">
      <div class="section-header">
        <v-icon color="white" small>mdi-file-document-outline</v-icon>
        <span class="section-header__title">Application Details</span>
      </div>
      <div class="section-body">
        <v-row>
          <v-col cols="12" md="6">
            <!-- Programme Name -->
            <div class="form-row">
              <label class="form-label">Programme Name</label>
              <div class="form-field">
                <v-text-field
                  dense
                  filled
                  v-model="formData.programmeName"
                  :error-messages="errorField.programmeName"
                ></v-text-field>
              </div>
            </div>

            <!-- Company Name -->
            <div class="form-row">
              <label class="form-label">Company Name</label>
              <div class="form-field">
                <v-text-field
                  dense
                  filled
                  disabled
                  v-model="formData.companyName"
                ></v-text-field>
              </div>
            </div>

            <!-- Subscription Date -->
            <div class="form-row">
              <label class="form-label">Subscription Date</label>
              <div class="form-field">
                <div class="rv-datepicker__trigger rv-datepicker__trigger--disabled">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-datepicker__icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                  </svg>
                  <span v-if="subscriptionDate" class="rv-datepicker__text">{{ subscriptionDate }}</span>
                  <span v-else class="rv-datepicker__placeholder">No date selected</span>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <!-- Refund Type -->
            <div class="form-row">
              <label class="form-label">Refund Type</label>
              <div class="form-field">
                <div class="rv-select" v-click-outside="() => refundTypeDropdownOpen = false">
                  <div
                    class="rv-select__trigger"
                    :class="{ 'rv-select__trigger--open': refundTypeDropdownOpen, 'rv-select__trigger--error': errorField.refundType }"
                    @click="refundTypeDropdownOpen = !refundTypeDropdownOpen"
                  >
                    <div class="rv-select__value">
                      <span v-if="formData.refundType === 1">Normal</span>
                      <span v-else-if="formData.refundType === 2">70% / 30%</span>
                      <span v-else class="rv-select__placeholder">Select refund type...</span>
                    </div>
                    <div class="rv-select__right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div class="rv-select__info" v-on="on" @click.stop>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-select__info-icon">
                              <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                            </svg>
                          </div>
                        </template>
                        <span>Manual Invoice will require 2 if refund type is 70/30</span>
                      </v-tooltip>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-select__arrow" :class="{ 'rv-select__arrow--open': refundTypeDropdownOpen }">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                      </svg>
                    </div>
                  </div>
                  <div v-if="refundTypeDropdownOpen" class="rv-select__dropdown">
                    <div class="rv-select__option" :class="{ 'rv-select__option--selected': formData.refundType === 1 }" @click="formData.refundType = 1; refundTypeDropdownOpen = false; changeRefundType()">Normal</div>
                    <div class="rv-select__option" :class="{ 'rv-select__option--selected': formData.refundType === 2 }" @click="formData.refundType = 2; refundTypeDropdownOpen = false; changeRefundType()">70% / 30%</div>
                  </div>
                  <div v-if="errorField.refundType" class="rv-select__error">{{ Array.isArray(errorField.refundType) ? errorField.refundType.join(', ') : errorField.refundType }}</div>
                </div>
              </div>
            </div>

            <!-- Request Invoice Amount -->
            <div v-show="requestManualInvoiceDisplay">
              <div class="form-row">
                <label class="form-label">Invoice Amount</label>
                <div class="form-field">
                  <v-text-field
                    dense
                    filled
                    type="number"
                    hide-spin-buttons
                    v-model="formData.requestManualInvoiceAmount"
                    :error-messages="errorField.requestManualInvoiceAmount"
                  ></v-text-field>
                </div>
              </div>
            </div>

            <!-- 70/30 -->
            <div v-show="seventyThirtyCase">
              <div class="form-row">
                <label class="form-label">70/30 Split</label>
                <div class="form-field form-field--inline">
                  <v-text-field
                    dense
                    filled
                    type="number"
                    hide-spin-buttons
                    label="70% Claim Amount"
                    v-model="formData.seventyPercent"
                    :error-messages="errorField.seventyPercent"
                  ></v-text-field>
                  <v-text-field
                    dense
                    filled
                    type="number"
                    hide-spin-buttons
                    label="30% Claim Amount"
                    v-model="formData.thirtyPercent"
                    :error-messages="errorField.thirtyPercent"
                  ></v-text-field>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- Grant Details & Form Details -->
    <div class="cards-grid">
      <!-- GRANT DETAILS -->
      <div class="cards-column">
        <div class="section-card">
          <div class="section-header">
            <v-icon color="white" small>mdi-certificate-outline</v-icon>
            <span class="section-header__title">Grant Details</span>
            <span
              class="status-pill"
              :class="caseIcon.grantIcon.color === 'green' ? 'status-pill--complete' : 'status-pill--incomplete'"
            >
              <svg v-if="caseIcon.grantIcon.color === 'green'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
              {{ caseIcon.grantIcon.color === 'green' ? 'Complete' : 'Incomplete' }}
            </span>
          </div>
          <div class="section-body">
            <!-- Auto-captured grant email data -->
            <div v-if="displayAutoCapturedData" class="grant-email-card">
              <div class="grant-email-card__header">
                <div class="grant-email-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                  </svg>
                </div>
                <span class="grant-email-card__title">Grant Email Details</span>
                <div class="grant-email-card__actions">
                  <button
                    class="ge-btn ge-btn--approve"
                    @click="embedGrantData(true)"
                    :disabled="!disabledApprovalGrantEmailBtn"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                    Approve
                  </button>
                  <button
                    class="ge-btn ge-btn--revert"
                    @click="embedGrantData(false)"
                    :disabled="disabledApprovalGrantEmailBtn"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                    </svg>
                    Revert
                  </button>
                </div>
              </div>
              <div class="grant-email-card__body">
                <div class="ge-rows">
                  <div class="ge-row">
                    <span class="ge-row__label">Company Name</span>
                    <span class="ge-row__value">{{ grantEmailData.hrdcCompanyName }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Programme Name</span>
                    <span class="ge-row__value">{{ grantEmailData.programmeName }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Price</span>
                    <span class="ge-row__value ge-row__value--highlight">{{ grantEmailData.price }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Grant Approval No.</span>
                    <span class="ge-row__value">{{ grantEmailData.grantApprovalNo }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Grant Approval Date</span>
                    <span class="ge-row__value">{{ grantEmailData.grantApprovalDate }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Subscription Date</span>
                    <span class="ge-row__value">{{ grantEmailData.trainingDate }}</span>
                  </div>
                </div>
                <div class="ge-attachment">
                  <div class="ge-attachment__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                    </svg>
                  </div>
                  <span class="ge-attachment__text">Grant Email Attachment</span>
                  <button class="ge-attachment__btn" @click="previewBlobAttachment()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                    Preview
                  </button>
                </div>
              </div>
            </div>

            <hr v-if="displayAutoCapturedData" class="section-divider" />

            <!-- Grant Approval No. -->
            <div class="form-row">
              <label class="form-label">Grant Approval No.</label>
              <div class="form-field">
                <div class="grant-input-wrap">
                  <v-text-field
                    dense
                    filled
                    v-model="formData.grantApprovalNo"
                    :error-messages="errorField.grantApprovalNo"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <button
                        class="grant-format-toggle"
                        :class="rareCaseGrantFlag ? 'grant-format-toggle--on' : 'grant-format-toggle--off'"
                        @click="toggleMarker"
                        v-on="on"
                      >
                        <span class="grant-format-toggle__track">
                          <span class="grant-format-toggle__thumb"></span>
                        </span>
                        <span class="grant-format-toggle__label">{{ rareCaseGrantFlag ? 'Validate' : 'Skip' }}</span>
                      </button>
                    </template>
                    <span>{{ rareCaseGrantFlag ? 'Will Check Grant Format' : 'No Check Grant Format' }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>

            <!-- Grant email attachment -->
            <div class="form-row">
              <label class="form-label">Grant Attachment</label>
              <div class="form-field">
                <div
                  class="file-card"
                  :class="formData.grantEmailAttachment ? 'file-card--has-file' : 'file-card--empty'"
                  @drop.prevent="addDropFile($event, 'grantEmailAttachment', false)"
                  @dragover.prevent
                >
                  <div class="file-card__icon-wrap">
                    <div class="file-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                      </svg>
                    </div>
                  </div>
                  <div class="file-card__info">
                    <span class="file-card__name">{{ formData.grantEmailAttachment ? formData.grantEmailAttachment.name : 'No file selected' }}</span>
                    <span class="file-card__hint">PDF or image</span>
                  </div>
                  <div class="file-card__actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <label class="file-card__btn" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                          <input type="file" class="file-card__hidden" accept=".pdf, image/*" @change="handleFileChange($event, 'grantEmailAttachment')" />
                        </label>
                      </template>
                      <span>Upload</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <button class="file-card__btn" @click="previewAttachment('grantEmailAttachment')" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                        </button>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="errorField.grantEmailAttachment" class="rv-select__error">
                  <ul v-if="Array.isArray(errorField.grantEmailAttachment)" class="rv-error-list"><li v-for="(msg, idx) in errorField.grantEmailAttachment" :key="'grantAtchErr-' + idx">{{ msg }}</li></ul>
                  <span v-else>{{ errorField.grantEmailAttachment }}</span>
                </div>
              </div>
            </div>

            <!-- Grant Approved Date -->
            <div class="form-row">
              <label class="form-label">Grant Approved Date</label>
              <div class="form-field">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="rv-datepicker__trigger"
                      :class="{ 'rv-datepicker__trigger--error': errorField.grantApprovalNoSubmitDate }"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-datepicker__icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                      </svg>
                      <span v-if="formData.grantApprovalNoSubmitDate" class="rv-datepicker__text">{{ formData.grantApprovalNoSubmitDate }}</span>
                      <span v-else class="rv-datepicker__placeholder">Select date...</span>
                    </div>
                  </template>
                  <v-date-picker
                    v-model="formData.grantApprovalNoSubmitDate"
                    no-title
                    scrollable
                    color="var(--app-accent)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
                <div v-if="errorField.grantApprovalNoSubmitDate" class="rv-select__error">{{ Array.isArray(errorField.grantApprovalNoSubmitDate) ? errorField.grantApprovalNoSubmitDate.join(', ') : errorField.grantApprovalNoSubmitDate }}</div>
              </div>
            </div>

            <!-- Grant Status -->
            <div class="form-row">
              <label class="form-label">Grant Status</label>
              <div class="form-field">
                <div class="rv-select" v-click-outside="() => grantStatusDropdownOpen = false">
                  <div
                    class="rv-select__trigger"
                    :class="{ 'rv-select__trigger--open': grantStatusDropdownOpen, 'rv-select__trigger--error': errorField.revertStatus }"
                    @click="grantStatusDropdownOpen = !grantStatusDropdownOpen"
                  >
                    <div class="rv-select__value">
                      <span v-if="formData.revertStatus !== null && formData.revertStatus !== undefined">{{ grantRevertOpts.find(function(i) { return i.value === formData.revertStatus }) ? grantRevertOpts.find(function(i) { return i.value === formData.revertStatus }).text : '' }}</span>
                      <span v-else class="rv-select__placeholder">Select grant status...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-select__arrow" :class="{ 'rv-select__arrow--open': grantStatusDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="grantStatusDropdownOpen" class="rv-select__dropdown">
                    <div
                      v-for="item in grantRevertOpts"
                      :key="'grant-' + item.value"
                      class="rv-select__option"
                      :class="{ 'rv-select__option--selected': formData.revertStatus === item.value }"
                      @click="formData.revertStatus = item.value; grantStatusDropdownOpen = false"
                    >{{ item.text }}</div>
                  </div>
                  <div v-if="errorField.revertStatus" class="rv-select__error">{{ Array.isArray(errorField.revertStatus) ? errorField.revertStatus.join(', ') : errorField.revertStatus }}</div>
                </div>
              </div>
            </div>

            <!-- Grant Remarks -->
            <div class="form-row">
              <label class="form-label">Grant Remarks</label>
              <div class="form-field">
                <v-textarea
                  dense
                  filled
                  auto-grow
                  v-model="formData.remarks"
                  :error-messages="errorField.remarks"
                ></v-textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FORM DETAILS -->
      <div class="cards-column">
        <div class="section-card">
          <div class="section-header">
            <v-icon color="white" small>mdi-file-document-edit-outline</v-icon>
            <span class="section-header__title">Form Details</span>
            <span
              class="status-pill"
              :class="caseIcon.formIcon.color === 'green' ? 'status-pill--complete' : 'status-pill--incomplete'"
            >
              <svg v-if="caseIcon.formIcon.color === 'green'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
              {{ caseIcon.formIcon.color === 'green' ? 'Complete' : 'Incomplete' }}
            </span>
          </div>
          <div class="section-body">
            <!-- JD14 -->
            <div class="form-row">
              <label class="form-label">JD14</label>
              <div class="form-field">
                <div
                  class="file-card"
                  :class="formData.jd14FileUrl ? 'file-card--has-file' : 'file-card--empty'"
                  @drop.prevent="addDropFile($event, 'jd14FileUrl')"
                  @dragover.prevent
                >
                  <div class="file-card__icon-wrap">
                    <div class="file-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                      </svg>
                    </div>
                  </div>
                  <div class="file-card__info">
                    <span class="file-card__name">{{ formData.jd14FileUrl ? formData.jd14FileUrl.name : 'No file selected' }}</span>
                    <span class="file-card__hint">PDF only</span>
                  </div>
                  <div class="file-card__actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <label class="file-card__btn" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                          <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 'jd14FileUrl')" />
                        </label>
                      </template>
                      <span>Upload</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <button class="file-card__btn" @click="previewAttachment('jd14FileUrl')" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                        </button>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="errorField.jd14FileUrl" class="rv-select__error">
                  <ul v-if="Array.isArray(errorField.jd14FileUrl)" class="rv-error-list"><li v-for="(msg, idx) in errorField.jd14FileUrl" :key="'jd14Err-' + idx">{{ msg }}</li></ul>
                  <span v-else>{{ errorField.jd14FileUrl }}</span>
                </div>
              </div>
            </div>

            <!-- T3 -->
            <div class="form-row">
              <label class="form-label">T3</label>
              <div class="form-field">
                <div
                  class="file-card"
                  :class="formData.t3FileUrl ? 'file-card--has-file' : 'file-card--empty'"
                  @drop.prevent="addDropFile($event, 't3FileUrl')"
                  @dragover.prevent
                >
                  <div class="file-card__icon-wrap">
                    <div class="file-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                      </svg>
                    </div>
                  </div>
                  <div class="file-card__info">
                    <span class="file-card__name">{{ formData.t3FileUrl ? formData.t3FileUrl.name : 'No file selected' }}</span>
                    <span class="file-card__hint">PDF only</span>
                  </div>
                  <div class="file-card__actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <label class="file-card__btn" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                          <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 't3FileUrl')" />
                        </label>
                      </template>
                      <span>Upload</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <button class="file-card__btn" @click="previewAttachment('t3FileUrl')" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                        </button>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="errorField.t3FileUrl" class="rv-select__error">
                  <ul v-if="Array.isArray(errorField.t3FileUrl)" class="rv-error-list"><li v-for="(msg, idx) in errorField.t3FileUrl" :key="'t3Err-' + idx">{{ msg }}</li></ul>
                  <span v-else>{{ errorField.t3FileUrl }}</span>
                </div>
              </div>
            </div>

            <!-- Attendance Form -->
            <div v-if="showAttendanceForm" class="form-row">
              <label class="form-label">Attendance Form</label>
              <div class="form-field">
                <div
                  class="file-card"
                  :class="formData.attendanceForm ? 'file-card--has-file' : 'file-card--empty'"
                  @drop.prevent="addDropFile($event, 'attendanceForm')"
                  @dragover.prevent
                >
                  <div class="file-card__icon-wrap">
                    <div class="file-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                      </svg>
                    </div>
                  </div>
                  <div class="file-card__info">
                    <span class="file-card__name">{{ formData.attendanceForm ? formData.attendanceForm.name : 'No file selected' }}</span>
                    <span class="file-card__hint">PDF only</span>
                  </div>
                  <div class="file-card__actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <label class="file-card__btn" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                          <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 'attendanceForm')" />
                        </label>
                      </template>
                      <span>Upload</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <button class="file-card__btn" @click="previewAttachment('attendanceForm')" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                        </button>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="errorField.attendanceForm" class="rv-select__error">
                  <ul v-if="Array.isArray(errorField.attendanceForm)" class="rv-error-list"><li v-for="(msg, idx) in errorField.attendanceForm" :key="'attFormErr-' + idx">{{ msg }}</li></ul>
                  <span v-else>{{ errorField.attendanceForm }}</span>
                </div>
              </div>
            </div>

            <!-- Attendance List -->
            <div v-if="showAttendanceList" class="form-row">
              <label class="form-label">Attendance List</label>
              <div class="form-field">
                <div
                  class="file-card"
                  :class="formData.attendanceList ? 'file-card--has-file' : 'file-card--empty'"
                  @drop.prevent="addDropFile($event, 'attendanceList')"
                  @dragover.prevent
                >
                  <div class="file-card__icon-wrap">
                    <div class="file-card__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                      </svg>
                    </div>
                  </div>
                  <div class="file-card__info">
                    <span class="file-card__name">{{ formData.attendanceList ? formData.attendanceList.name : 'No file selected' }}</span>
                    <span class="file-card__hint">PDF only</span>
                  </div>
                  <div class="file-card__actions">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <label class="file-card__btn" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                          <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 'attendanceList')" />
                        </label>
                      </template>
                      <span>Upload</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <button class="file-card__btn" @click="previewAttachment('attendanceList')" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                        </button>
                      </template>
                      <span>Preview</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="errorField.attendanceList" class="rv-select__error">
                  <ul v-if="Array.isArray(errorField.attendanceList)" class="rv-error-list"><li v-for="(msg, idx) in errorField.attendanceList" :key="'attListErr-' + idx">{{ msg }}</li></ul>
                  <span v-else>{{ errorField.attendanceList }}</span>
                </div>
              </div>
            </div>

            <!-- Form Revert Date -->
            <div class="form-row">
              <label class="form-label">Form Revert Date</label>
              <div class="form-field">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="rv-datepicker__trigger"
                      :class="{ 'rv-datepicker__trigger--error': errorField.formSubmitDate }"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-datepicker__icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                      </svg>
                      <span v-if="formData.formSubmitDate" class="rv-datepicker__text">{{ formData.formSubmitDate }}</span>
                      <span v-else class="rv-datepicker__placeholder">Select date...</span>
                    </div>
                  </template>
                  <v-date-picker
                    v-model="formData.formSubmitDate"
                    no-title
                    scrollable
                    color="var(--app-accent)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu2.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
                <div v-if="errorField.formSubmitDate" class="rv-select__error">{{ Array.isArray(errorField.formSubmitDate) ? errorField.formSubmitDate.join(', ') : errorField.formSubmitDate }}</div>
              </div>
            </div>

            <!-- Form Status -->
            <div class="form-row">
              <label class="form-label">Form Status</label>
              <div class="form-field">
                <div class="rv-select" v-click-outside="() => formStatusDropdownOpen = false">
                  <div
                    class="rv-select__trigger"
                    :class="{ 'rv-select__trigger--open': formStatusDropdownOpen, 'rv-select__trigger--error': errorField.formRevertStatus }"
                    @click="formStatusDropdownOpen = !formStatusDropdownOpen"
                  >
                    <div class="rv-select__value">
                      <span v-if="formData.formRevertStatus !== null && formData.formRevertStatus !== undefined">{{ formRevertOpts.find(function(i) { return i.value === formData.formRevertStatus }) ? formRevertOpts.find(function(i) { return i.value === formData.formRevertStatus }).text : '' }}</span>
                      <span v-else class="rv-select__placeholder">Select form status...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-select__arrow" :class="{ 'rv-select__arrow--open': formStatusDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="formStatusDropdownOpen" class="rv-select__dropdown">
                    <div
                      v-for="item in formRevertOpts"
                      :key="'form-' + item.value"
                      class="rv-select__option"
                      :class="{ 'rv-select__option--selected': formData.formRevertStatus === item.value }"
                      @click="formData.formRevertStatus = item.value; formStatusDropdownOpen = false"
                    >{{ item.text }}</div>
                  </div>
                  <div v-if="errorField.formRevertStatus" class="rv-select__error">{{ Array.isArray(errorField.formRevertStatus) ? errorField.formRevertStatus.join(', ') : errorField.formRevertStatus }}</div>
                </div>
              </div>
            </div>

            <!-- Form Remarks -->
            <div class="form-row">
              <label class="form-label">Form Remarks</label>
              <div class="form-field">
                <v-textarea
                  dense
                  filled
                  auto-grow
                  v-model="formData.formRemarks"
                  :error-messages="errorField.formRemarks"
                ></v-textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <HrdcLoader
      :loadingDialog="loadingDialog"
      :loadingText="loadingText"
    ></HrdcLoader>
  </v-container>
</template>

<script>
import moment from "moment";
import Api from "@/objects/api";
import { mapState } from "vuex";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";
import TrainingDaysListingComponent from "@/components/views/TrainingDaysListingComponent";

export default {
  mixins: [hrdcFunction],
  components: {
    TrainingDaysListingComponent,
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
    submitProperties() {
      let status = null;
      if (
        this.formData.revertStatus == 0 ||
        this.formData.formRevertStatus == 0
      ) {
        status = {
          text: "Submit Incomplete Form",
          color: "error",
          msg: "Please be informed that this form is incomplete, do you wish to proceed ?",
        };
      } else {
        if (
          this.formData.jd14FileUrl &&
          this.formData.t3FileUrl &&
          this.formData.grantApprovalNo
        ) {
          status = {
            text: "Submit Complete Form",
            color: "success",
            msg: "Please confirm that you wish to submit this form & HRDC Invoice will be generate automatically",
          };
        } else {
          status = {
            text: "Submit Incomplete Form",
            color: "error",
            msg: "Please be informed that this form is incomplete, do you wish to proceed ?",
          };
        }
      }

      return status;
    },
    subscriptionDate() {
      return this.formData.subscriptionDateRange.join(" - ");
    },
    seventyThirtyCase() {
      if (this.formData.refundType == 2) {
        return true;
      }
      return false;
    },
    showAttendanceForm() {
      // taxPOD (hrdc) = no attendance form; all others = yes
      return this.model.serviceKey !== "hrdc";
    },
    showAttendanceList() {
      // only tpdiy has attendance list
      return this.model.serviceKey === "hrdc_tpdiy";
    },
    caseIcon() {
      let grantIcon = {},
        formIcon = {};
      if (
        this.formData.jd14FileUrl &&
        this.formData.t3FileUrl &&
        this.formData.formRevertStatus &&
        this.formData.formSubmitDate
      ) {
        formIcon.icon = "mdi-check-circle";
        formIcon.color = "green";
      } else {
        formIcon.icon = "mdi-close-circle";
        formIcon.color = "red";
      }

      if (
        this.formData.grantApprovalNo &&
        this.formData.revertStatus &&
        this.formData.grantApprovalNoSubmitDate
      ) {
        grantIcon.icon = "mdi-check-circle";
        grantIcon.color = "green";
      } else {
        grantIcon.icon = "mdi-close-circle";
        grantIcon.color = "red";
      }

      return {
        formIcon,
        grantIcon,
      };
    },
    displayAutoCapturedData() {
      if (this.grantEmailData.hrdcCompanyName) {
        return true;
      }

      return false;
    },
  },
  props: ["params"],
  data: () => ({
    apiSubmit: new Api(),
    apiGetApplicationAttachment: new Api(),
    apiRevertCase: new Api(),
    apiDownloadOrPreviewAttachment: new Api(),
    apiGetXeroRefreshToken: new Api(),
    apiRefreshXeroToken: new Api(),
    apiGetXeroTenantId: new Api(),
    apiRequestXeroAccessToken: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    loadingDialog: false,
    loadingText: null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu2: false,
    currentStagePriority: 0,
    formData: {
      applicationNo: null,
      programmeName: null,
      grantApprovalNo: null,
      grantApprovalNoSubmitDate: null,
      formSubmitDate: null,
      jd14FileUrl: null,
      t3FileUrl: null,
      remarks: null,
      formRemarks: null,
      revertStatus: null, // Page revertGrantStatus
      formRevertStatus: null,
      dbRevertGrantStatus: null, // Database revertGrantStatus
      subscriptionMenu: false,
      subscriptionDateRange: [],
      refundType: null,
      seventyPercent: null,
      thirtyPercent: null,
      totalPrice: null,
      companyName: null,
      requestManualInvoiceAmount: null,
      grantEmailAttachment: null,
      oriCompanyName: null,
      oriPrice: null,
      oriGrantApprovalNo: null,
      oriProgrammeName: null,
      oriGrantApprovalDate: null,
      oriEmailAttachment: null,
      oriGrantStatus: null,
      attendanceForm: null,
      attendanceList: null,
    },
    errorField: {
      applicationNo: null,
      programmeName: null,
      grantApprovalNo: null,
      grantApprovalNoSubmitDate: null,
      formSubmitDate: null,
      jd14FileUrl: null,
      t3FileUrl: null,
      remarks: null,
      formRemarks: null,
      revertStatus: null,
      formRevertStatus: null,
      subscriptionMenu: null,
      subscriptionDateRange: null,
      refundType: null,
      seventyPercent: null,
      thirtyPercent: null,
      totalPrice: null,
      requestManualInvoiceAmount: null,
      grantEmailAttachment: null,
      attendanceForm: null,
      attendanceList: null,
    },
    revertFormDialog: false,
    revertCaseDialog: false,
    refundTypeDropdownOpen: false,
    grantStatusDropdownOpen: false,
    formStatusDropdownOpen: false,
    editMode: false,
    btnDisabled: false,
    requestManualInvoiceDisplay: false,
    rareCaseGrantFlag: true,
    displayRevertBtn: false,
    originalGrantData: {
      emailAttachment: null,
    },
    grantEmailData: {
      emailAttachment: null,
      hrdcCompanyName: null,
      price: null,
      grantApprovalNo: null,
      programmeName: null,
      grantApprovalDate: null,
      trainingDate: null,
    },
    disabledApprovalGrantEmailBtn: true,
  }),
  async created() {
    this.showLoadingDialog();
    this.formData.applicationNo = this.$route.query._ausk;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Events Assignation.
    this.serviceDataAssignation(this.model.serviceKey);

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/revert_form/create-revert-form`,
        method: "post",
      },
      apiGetApplicationAttachment: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-application-attachment`,
        method: "post",
      },
      apiRevertCase: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/revert_form/revert-case`,
        method: "post",
      },
      apiDownloadOrPreviewAttachment: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/azure-download-or-preview-application-attachment`,
      },
      apiGetXeroRefreshToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/get-xero-token?date=${moment().format(
          "YYYY-MM-DD"
        )}`,
      },
      apiRefreshXeroToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/update-xero-token`,
        method: "put",
      },
      apiRequestXeroAccessToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/request-xero-access-token`,
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.stages = await this.hrdcData.allStages;
    this.currentStagePriority =
      this.hrdcData.stageIndex[this.$store.state.hrdc.data.stageId];

    this.rolesAssignation(this.auth.roles);
    if (!this.isHrdcAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    const grantApprovalStage =
      this.hrdcData.stageIndex[
        this.hrdcData.stagePriority.grantApprovalNoSubmitted
      ];

    const totallyIncompleteStage =
      this.hrdcData.stageIndex[
        this.hrdcData.stagePriority.clientRevertFormIncomplete
      ];

    let stageErrorMsg = null;
    let checkGreaterStage = this.hrdcData.stageSlug.clientRevertT3Form;
    if (
      this.currentStagePriority > grantApprovalStage &&
      this.currentStagePriority <= totallyIncompleteStage
    ) {
      stageErrorMsg = "This form is partially filled in";
      checkGreaterStage = grantApprovalStage;
    }

    this.checkFormAlreadyFilledGte(
      this.currentStagePriority,
      checkGreaterStage,
      stageErrorMsg
    );

    this.checkFormNotYetFilledLesser(
      this.currentStagePriority,
      this.hrdcData.stageSlug.sentConfirmationEmailToClient
    );

    // Get is there any uploaded attachment for jd14/t3.
    this.apiGetApplicationAttachment.setParams({
      applicationNo: this.$route.query._ausk,
    });
    this.apiGetApplicationAttachment.fetch();
    this.apiGetApplicationAttachment.setCallbackCompleted((response) => {
      try {
        const { data } = response;

        // General details.
        let grantApprovalNo = null;
        let grantApprovalNoSubmitDate = null;

        // Assign latest subscription date range.
        const subscriptionDate = data.ApplicationLog.find(
          (item) =>
            item.stageId ==
            this.hrdcData.stagePriority.subscriptionDateScheduled
        );

        if (subscriptionDate !== undefined) {
          this.formData.subscriptionDateRange = [
            moment(subscriptionDate.startDate, "YYYY-MM-DD HH:mm:ssZ").format(
              "DD/MM/YYYY"
            ),
            moment(subscriptionDate.endDate, "YYYY-MM-DD HH:mm:ssZ").format(
              "DD/MM/YYYY"
            ),
          ];
        }
        this.formData.companyName = data.oriCompanyName.toUpperCase();
        this.formData.programmeName = data.programmeName;
        this.formData.totalPrice = data.totalPrice;
        this.formData.refundType = data.refundType;
        this.formData.seventyPercent = Number(data.seventyPercentPrice).toFixed(
          2
        );
        this.formData.thirtyPercent = Number(data.thirtyPercentPrice).toFixed(
          2
        );
        this.formData.requestManualInvoiceAmount = data.totalPrice; // Default price.

        // Assign original data to re-append if user click 'Revert'.
        this.formData.oriCompanyName = data.oriCompanyName.toUpperCase();
        this.formData.oriPrice = data.totalPrice;
        this.formData.oriGrantApprovalNo = null;
        this.formData.oriProgrammeName = data.programmeName;
        this.formData.oriGrantApprovalDate = null;
        this.formData.oriEmailAttachment = null;
        this.formData.dbRevertGrantStatus = data.revertGrantStatus;

        // Append auto captured grant email data & display.
        const grantEmailHookData = JSON.parse(data.grantEmailHookData);

        if (grantEmailHookData) {
          this.grantEmailData.hrdcCompanyName =
            grantEmailHookData.hrdcCompanyName;
          this.grantEmailData.price = grantEmailHookData.price;
          this.grantEmailData.grantApprovalNo =
            grantEmailHookData.grantApprovalNo;
          this.grantEmailData.programmeName = grantEmailHookData.programmeName;
          this.grantEmailData.grantApprovalDate = moment(
            grantEmailHookData.grantApprovalDate
          ).format("YYYY-MM-DD");
          this.grantEmailData.emailAttachment =
            grantEmailHookData.emailAttachment;
          this.grantEmailData.trainingDate =
            grantEmailHookData.trainingDate ?? "-";
        }

        if (this.editMode) {
          // Grant Details.
          const grantRemarkArr = [
            this.hrdcData.stagePriority.grantApprovalNoSubmitted,
          ];
          grantApprovalNo = data.grantApprovalNo;

          // Check whether grant approval no. has been submitted or not.
          const checkGrant = data.ApplicationLog.find((obj) =>
            grantRemarkArr.includes(obj.stageId)
          );

          if (checkGrant !== undefined) {
            if (checkGrant.startDate) {
              grantApprovalNoSubmitDate = moment(checkGrant.startDate).format(
                "YYYY-MM-DD"
              );
            }
          }

          this.formData.grantApprovalNo = grantApprovalNo;

          // Check rare case flag.
          if (grantApprovalNo) {
            this.rareCaseGrantFlag =
              !this.hasMoreThanTwoUnderscores(grantApprovalNo);
          }

          this.formData.grantApprovalNoSubmitDate = grantApprovalNoSubmitDate;
          this.formData.revertStatus = data.revertGrantStatus;
          if (data.ApplicationLog.length > 0) {
            const grantRemarks = data.ApplicationLog.find((item) =>
              grantRemarkArr.includes(item.stageId)
            );
            if (grantRemarks) {
              this.formData.remarks = grantRemarks.remarks;
            }
          }

          // Form details.
          const jd14T3FormSubmittedStageId =
            this.hrdcData.stagePriority.jd14T3FormSubmitted;

          for (const item of data.ApplicationAttachment) {
            // Create a Blob object from the data
            const blob = new Blob([new Uint8Array(item.dataArray)]);

            // Create the File object
            const file = new File([blob], item.fileName, {
              type: "application/pdf",
            });

            switch (item.type) {
              case "JD14":
                this.formData.jd14FileUrl = file;
                break;

              case "T3":
                this.formData.t3FileUrl = file;
                break;

              case "HRDC_GRANT_EMAIL":
                this.formData.grantEmailAttachment = file;
                break;

              case "ATTENDANCE_FORM":
                this.formData.attendanceForm = file;
                break;

              case "ATTENDANCE_LIST":
                this.formData.attendanceList = file;
                break;
            }
          }

          let jd14T3FormSubmittedDate = null;

          const checkFormSubmitted = data.ApplicationLog.find(
            (obj) => obj.stageId == jd14T3FormSubmittedStageId
          );

          if (checkFormSubmitted !== undefined) {
            jd14T3FormSubmittedDate = moment(
              checkFormSubmitted.startDate
            ).format("YYYY-MM-DD");
          }

          this.formData.formSubmitDate = jd14T3FormSubmittedDate;
          this.formData.formRevertStatus = data.revertFormStatus;
          if (data.ApplicationLog.length > 0) {
            const formRemarks = data.ApplicationLog.find(
              (item) => item.stageId == jd14T3FormSubmittedStageId
            );
            if (formRemarks) {
              this.formData.formRemarks = formRemarks.remarks;
            }
          }

          if (data.refundType == 1) {
            this.requestManualInvoiceDisplay = true;
          }

          // If got assign request manual invoice amount, then assign request manual invoice amount, else use application pricing.
          if (data.requestManualInvoiceAmount) {
            this.formData.requestManualInvoiceAmount =
              data.requestManualInvoiceAmount;
          }

          // If passed stage of pending grant/form, then cannot be revert anymore.
          if (
            this.currentStagePriority <
            this.hrdcData.stageSlug.clientRevertT3Form
          ) {
            this.displayRevertBtn = true;
          }

          // Assign original data to re-append if user click 'Revert'.
          this.formData.oriGrantApprovalNo = grantApprovalNo;
          this.formData.oriGrantApprovalDate = grantApprovalNoSubmitDate;
          this.formData.oriGrantStatus = data.revertGrantStatus;
        } else {
          this.requestManualInvoiceDisplay = true;
        }

        this.hideLoadingDialog();
      } catch (err) {
        console.log(err);
      }
    });
  },
  methods: {
    handleFileChange(event, key) {
      const file = event.target.files[0];
      if (file) {
        this.formData[key] = file;
      }
    },
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      const fieldLabels = {
        requestManualInvoiceAmount: "Request Invoice Amount",
        grantApprovalNo: "Grant Approval No",
        grantApprovalNoSubmitDate: "Grant Approved Date",
        formSubmitDate: "Form Revert Date",
        revertStatus: "Grant Status",
        formRevertStatus: "Form Status",
        jd14FileUrl: "JD14",
        t3FileUrl: "T3",
        grantEmailAttachment: "Grant Attachment",
      };
      for (const key in response.data) {
        this.errorField[key] = null;
        let errors = response.data[key];
        // Fix "undefined is required" messages
        if (Array.isArray(errors)) {
          errors = errors.map(function(msg) {
            return msg.replace(/^undefined\b/, fieldLabels[key] || key);
          });
        } else if (typeof errors === 'string') {
          errors = errors.replace(/^undefined\b/, fieldLabels[key] || key);
        }
        this.errorField[key] = errors;
      }
    },
    addDropFile(e, key, strictPdf = true) {
      let file = e.dataTransfer.files[0];

      if (strictPdf) {
        if (!file.type.match("pdf.*")) {
          this.errorField[key] = "Please select pdf file format";
          return;
        }
      }

      this.formData[key] = file;
    },
    modalRevertForm() {
      this.revertFormDialog = !this.revertFormDialog;
      this.submit();
    },
    changeRefundType() {
      if (this.formData.refundType == 1) {
        this.formData.seventyPercent = null;
        this.formData.thirtyPercent = null;

        // Enable request manual invoice amount.
        this.requestManualInvoiceDisplay = true;
      } else {
        // Assign split amount.
        const totalPrice = this.formData.totalPrice;
        this.formData.seventyPercent = (totalPrice * 0.7).toFixed(2);
        this.formData.thirtyPercent = (totalPrice * 0.3).toFixed(2);

        // Disable request manual invoice amount.
        this.requestManualInvoiceDisplay = false;
      }
    },
    revertCase() {
      this.apiRevertCase.setParams({
        applicationUuid: this.formData.applicationNo,
      });
      this.apiRevertCase.setCallbackCompleted((response) => {
        try {
          this.showLoadingDialog();
          this.revertCaseDialog = false;
          const { status, data } = response;

          if (!status) {
            this.$store.dispatch("showMessage", {
              message: data,
              messageType: "error",
              timeout: 2000,
            });
            return;
          }

          this.$store.dispatch("showMessage", {
            message: data,
            messageType: "success",
            timeout: 2000,
          });

          this.$router.push({
            name: "HrdcApplication",
            query: {
              viewId: this.$store.state.hrdc.data.viewId,
            },
          });
        } catch (err) {
          console.log(err);
        } finally {
          this.hideLoadingDialog();
        }
      });
      this.apiRevertCase.fetch();
    },
    redirectBack() {
      let route = "HrdcApplication";
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state.hrdc.data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
    },
    toggleMarker() {
      this.rareCaseGrantFlag = !this.rareCaseGrantFlag;
    },
    hasMoreThanTwoUnderscores(word) {
      return word.split("_").length > 3;
    },
    async previewBlobAttachment() {
      this.showLoadingDialog();

      let fileUrl = this.grantEmailData.emailAttachment;
      fileUrl = fileUrl.replace(/\.[^.]+$/, (match) => match.toLowerCase());

      await this.$axios
        .get(this.apiDownloadOrPreviewAttachment.url, {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            filePath: fileUrl,
          },
        })
        .then((response) => {
          const blobUrl = URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );

          window.open(blobUrl, "_blank");

          this.hideLoadingDialog();
        })
        .catch((error) => {
          if ((error.response.status == 404) | true) {
            this.$store.dispatch("showMessage", {
              message:
                "Failed to Preview/Download attachment, kindly contact administrator",
              messageType: "error",
              timeout: 2000,
            });
          }
          this.hideLoadingDialog();
        });
    },
    previewAttachment(fileType) {
      try {
        if (!this.formData[fileType]) {
          this.$store.dispatch("showMessage", {
            message: "No Preview Available",
            messageType: "info",
          });
          return;
        }

        let url = null;
        let newWindow = null;
        switch (fileType) {
          default:
            url = URL.createObjectURL(this.formData[fileType]);
            newWindow = window.open(url, "_blank");
            break;
        }

        if (newWindow) {
          newWindow.onload = function () {
            // Revoke the object URL when the window is closed
            newWindow.addEventListener("beforeunload", function () {
              URL.revokeObjectURL(url);
            });
          };
        }
      } catch {
        this.previewBlobAttachment();
      }
    },
    embedGrantData(approval) {
      this.showLoadingDialog();

      this.disabledApprovalGrantEmailBtn = !this.disabledApprovalGrantEmailBtn;

      // Embed
      if (approval) {
        this.formData.grantApprovalNo = this.grantEmailData.grantApprovalNo;
        this.formData.revertStatus = 1;
        this.formData.programmeName = this.grantEmailData.programmeName;
        this.formData.grantApprovalNoSubmitDate =
          this.grantEmailData.grantApprovalDate;
        this.formData.grantEmailAttachment = {
          name: "Grant Email Attachment.pdf",
        };
      }

      // Discharge
      if (!approval) {
        this.formData.grantApprovalNo = this.formData.oriGrantApprovalNo;
        this.formData.programmeName = this.formData.oriProgrammeName;
        this.formData.grantApprovalNoSubmitDate =
          this.formData.oriGrantApprovalDate;
        this.formData.grantEmailAttachment = null;
        this.formData.revertStatus = this.formData.oriGrantStatus;
      }

      this.hideLoadingDialog();
    },
    successRedirect(data) {
      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: "ViewHrdcApplication",
        query: {
          viewId: this.$store.state.hrdc.data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
      this.$store.dispatch("showMessage", {
        message: data,
        messageType: "success",
        timeout: 2000,
      });
    },
    async submit() {
      this.showLoadingDialog();
      this.loadingText = "Submitting Grant & Form...";
      // Generate Form Data to handle multipart/form-data
      const fd = new FormData();
      fd.append("applicationUuid", this.formData.applicationNo);
      fd.append("remarks", this.formData.remarks);
      fd.append("programmeName", this.formData.programmeName);
      fd.append("grantApprovalNo", this.formData.grantApprovalNo);
      fd.append(
        "grantApprovalNoSubmitDate",
        this.formData.grantApprovalNoSubmitDate
      );
      fd.append("referById", this.auth.uuid);
      fd.append("jd14FileUrl", this.formData.jd14FileUrl);
      fd.append("t3FileUrl", this.formData.t3FileUrl);
      fd.append("revertStatus", this.formData.revertStatus); // Grant Revert Status
      fd.append("refundType", this.formData.refundType);
      fd.append("seventyPercent", this.formData.seventyPercent);
      fd.append("thirtyPercent", this.formData.thirtyPercent);
      fd.append("totalPrice", this.formData.totalPrice);
      fd.append("editMode", this.editMode);
      fd.append("formSubmitDate", this.formData.formSubmitDate);
      fd.append("formRevertStatus", this.formData.formRevertStatus); // Form Revert Status
      fd.append("formRemarks", this.formData.formRemarks);
      fd.append(
        "requestManualInvoiceAmount",
        this.formData.requestManualInvoiceAmount || ""
      );
      fd.append("rareCaseGrantFlag", this.rareCaseGrantFlag);
      if (this.showAttendanceForm) {
        fd.append("attendanceForm", this.formData.attendanceForm);
      }
      if (this.showAttendanceList) {
        fd.append("attendanceList", this.formData.attendanceList);
      }
      fd.append("hrdcType", this.hrdcType);

      const uploadFiles = ["jd14FileUrl", "t3FileUrl", "grantEmailAttachment"];
      if (this.showAttendanceForm) uploadFiles.push("attendanceForm");
      if (this.showAttendanceList) uploadFiles.push("attendanceList");
      fd.append("uploadFiles", uploadFiles);

      // If not File type, then will not do any checking for this file.
      let grantEmailAttachment = this.grantEmailData.emailAttachment;

      // If is edit mode & grant issue, then remove the grantEmailAttachment.
      if (this.editMode && !this.formData.revertStatus) {
        grantEmailAttachment = null;
      }

      let isGrantFileInstance = false;
      if (this.formData.grantEmailAttachment instanceof File) {
        grantEmailAttachment = this.formData.grantEmailAttachment;
        isGrantFileInstance = true;
      }
      fd.append("grantEmailAttachment", grantEmailAttachment);
      fd.append("isGrantFileInstance", isGrantFileInstance);
      fd.append("oriCompanyName", this.formData.companyName);

      this.apiSubmit.setParams(fd);
      this.apiSubmit.setCallbackError(() => {
        this.hideLoadingDialog();
        this.$store.dispatch("showMessage", {
          message: "Something went wrong. Please try again later.",
          messageType: "error",
          timeout: 2000,
        });
      });
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          const applicationData = response.application;

          if (!response.status) {
            this.showErrorMessage(response);
            if (response.message) {
              this.$store.dispatch("showMessage", {
                message: response.message,
                messageType: "error",
                timeout: 2000,
              });
            }

            this.hideLoadingDialog();
            return false;
          }

          // Response success, Grant Completed, Form Completed, current stage is before completed stage, HRDC Invoice No. is empty only need to generate HRDC invoice.
          if (
            response.status &&
            !applicationData.manualInvoiceToHrdc &&
            this.formData.revertStatus &&
            this.formData.formRevertStatus &&
            this.currentStagePriority <
              this.hrdcData.stageSlug.clientRevertT3Form
          ) {
            this.loadingText = "Generating HRDC Invoice...";
            const applicationLogData = applicationData.ApplicationLog.find(
              (item) =>
                item.stageId ==
                  this.hrdcData.stagePriority.subscriptionDateScheduled &&
                item.status == null
            );
            const trainingStartDate = this.convertDateFormat(
              applicationLogData.startDate
            );
            const trainingEndDate = this.convertDateFormat(
              applicationLogData.endDate
            );
            const trainingDate = `${trainingStartDate} to ${trainingEndDate}`;

            // Generate HRDC Invoice when completed.
            this.apiGetXeroRefreshToken.setCallbackCompleted(
              async (xeroTokenRes) => {
                try {
                  if (!xeroTokenRes || !xeroTokenRes.status) {
                    throw new Error(
                      "Unable to generate HRDC Invoice due to XERO invalid response, please contact administrator for assistance (1)"
                    );
                  }

                  // Check got valid refresh token or not, if yes, can direct call XERO API.
                  if (xeroTokenRes.data) {
                    const refreshToken = xeroTokenRes.data.token;

                    const token = await this.xeroRequestAccessToken(
                      this.apiRequestXeroAccessToken.url,
                      this.$store.state.auth.data.token,
                      refreshToken
                    );

                    const accessToken = token.data.access_token;

                    // Refresh the new refresh token in db.
                    this.apiRefreshXeroToken.setParams({
                      refresh_token: token.data.refresh_token,
                      token_id: xeroTokenRes.data.id,
                    });
                    this.apiRefreshXeroToken.fetch();

                    const connectionResponse = await this.xeroRequestTenantId({
                      url: `${
                        this.$service[this.service.key]
                      }/v1/en/console/xero/get-xero-tenant-id`,
                      headers: {
                        Authorization: `Bearer ${this.$store.state.auth.data.token}`,
                      },
                      postData: {
                        accessToken,
                      },
                    });

                    if (!connectionResponse || !connectionResponse.status) {
                      throw new Error(
                        "Unable to generate HRDC Invoice due to XERO invalid response, please contact administrator for assistance (2)"
                      );
                    }

                    const connectionData = connectionResponse.data;
                    const connection =
                      connectionData[connectionData.length - 1];
                    const tenantId = connection.tenantId;

                    const ContactID = process.env.VUE_APP_XERO_HRDC_CONTACT_ID;
                    const Code = process.env.VUE_APP_XERO_HRDC_ACCOUNT_CODE;
                    const TaxType =
                      process.env.VUE_APP_XERO_HRDC_ACCOUNT_TAX_TYPE;

                    // Get TaxRates
                    const taxRateObj = await this.xeroCallApi({
                      authorization: this.$store.state.auth.data.token,
                      service_key: this.model.serviceKey,
                      access_token: accessToken,
                      xero_tenant_id: tenantId,
                      api_type: "get_tax_rates",
                      method: "get",
                      postData: null,
                      url_suffix: `${TaxType}`,
                    });

                    const [taxRate] = taxRateObj.data.TaxRates.map(
                      (item) => item.EffectiveRate
                    );

                    // Start to do looping based on refund type (normal/70+30)
                    const LineItems = [];
                    let xeroProcessCount = 0;
                    const descriptionData = {
                      programmeName: this.formData.programmeName,
                      trainingDate,
                      companyName: applicationData.oriCompanyName,
                      grantApprovalNo: this.formData.grantApprovalNo,
                      note: null,
                    };

                    if (this.formData.refundType == 1) {
                      const {
                        unitAmount: requestInvoiceUnitAmount,
                        taxAmount: requestInvoiceTaxAmount,
                      } = this.calculateLineAmounts(
                        this.formData.requestManualInvoiceAmount,
                        taxRate
                      );

                      // Normal Claim
                      LineItems.push({
                        Description:
                          this.generateHrdcInvoiceDesc(descriptionData),
                        Quantity: 1,
                        LineAmount: requestInvoiceUnitAmount,
                        TaxType,
                        AccountCode: Code,
                        TaxAmount: requestInvoiceTaxAmount,
                        Tracking: [
                          { Name: "Division", Option: "taxPOD" },
                          {
                            Name: "MyInvois Classification",
                            Option: "022 - Others",
                          },
                        ],
                      });
                    }

                    if (this.formData.refundType == 2) {
                      // 70+30 Claim
                      const {
                        unitAmount: requestInvoice70UnitAmount,
                        taxAmount: requestInvoice70TaxAmount,
                      } = this.calculateLineAmounts(
                        this.formData.seventyPercent,
                        taxRate
                      );
                      const {
                        unitAmount: requestInvoice30UnitAmount,
                        taxAmount: requestInvoice30TaxAmount,
                      } = this.calculateLineAmounts(
                        this.formData.thirtyPercent,
                        taxRate
                      );

                      const additionalNote30 = `RM ${this.formData.thirtyPercent} - 30 % Upfront Payment`;
                      descriptionData.note = additionalNote30;
                      const Description30 =
                        this.generateHrdcInvoiceDesc(descriptionData);

                      descriptionData.note = `${additionalNote30}, RM ${this.formData.seventyPercent} - 70% Payment Upon Claim Approval.`;
                      const Description70 =
                        this.generateHrdcInvoiceDesc(descriptionData);

                      LineItems.push(
                        // 70%
                        {
                          Description: Description70,
                          Quantity: 1,
                          LineAmount: requestInvoice70UnitAmount,
                          TaxType,
                          AccountCode: Code,
                          TaxAmount: requestInvoice70TaxAmount,
                          Tracking: [
                            { Name: "Division", Option: "taxPOD" },
                            {
                              Name: "MyInvois Classification",
                              Option: "022 - Others",
                            },
                          ],
                        },
                        // 30%
                        {
                          Description: Description30,
                          Quantity: 1,
                          LineAmount: requestInvoice30UnitAmount,
                          TaxType,
                          AccountCode: Code,
                          TaxAmount: requestInvoice30TaxAmount,
                          Tracking: [
                            { Name: "Division", Option: "taxPOD" },
                            {
                              Name: "MyInvois Classification",
                              Option: "022 - Others",
                            },
                          ],
                        }
                      );
                    }

                    for (const LineItem of LineItems) {
                      // Construct data needed to request api to XERO.
                      const invoicePostData = {
                        Invoices: [
                          {
                            Type: this.INVOICE_TYPE,
                            Contact: {
                              ContactID,
                            },
                            Reference: this.TAXPOD_INVOICE_REFERENCE,
                            LineItems: [LineItem],
                            Status: this.getInvoiceStatus(),
                            DueDate: moment().format("YYYY-MM-DD"),
                            BrandingThemeID:
                              process.env.VUE_APP_XERO_BRANDING_THEME_ID,
                          },
                        ],
                      };

                      // Call XERO generate invoice api.
                      const generateInvoiceRes = await this.xeroCallApi({
                        authorization: this.$store.state.auth.data.token,
                        service_key: this.model.serviceKey,
                        access_token: accessToken,
                        xero_tenant_id: tenantId,
                        api_type: "post_invoices",
                        method: "post",
                        postData: invoicePostData,
                      });
                      const generateInvoiceResData = generateInvoiceRes.data;

                      if (
                        !generateInvoiceRes ||
                        generateInvoiceRes.status !== 200 ||
                        generateInvoiceResData.Status !== "OK"
                      ) {
                        throw new Error(
                          "HRDC Invoice created, but failed to upload invoice to system, please contact administrator for assistance"
                        );
                      }

                      // Construct GET HRDC Invoice attachments data.
                      const invoiceDetails =
                        generateInvoiceResData.Invoices.map((item) => {
                          return {
                            InvoiceID: item.InvoiceID, // A xero unique Invoice uuid
                            InvoiceNumber: item.InvoiceNumber, // e.g. YGC-XXXXXX
                            InvoiceDate: item.DueDateString,
                          };
                        });

                      // Call XERO GET Invoice via pdf api. (XERO API return PDF as pdf binary string type).
                      const hrdcInvoiceAtchRes = await this.xeroCallApi({
                        authorization: this.$store.state.auth.data.token,
                        service_key: this.model.serviceKey,
                        access_token: accessToken,
                        xero_tenant_id: tenantId,
                        api_type: "get_invoices",
                        method: "get",
                        postData: null,
                        url_suffix: `${invoiceDetails[0].InvoiceID}`,
                        accept_header: "application/pdf",
                        config: {
                          responseType: "arraybuffer", // Response received will be an PDF type of array buffer.
                          responseEncoding: "binary", // Response encoding using binary.
                        },
                      });

                      // Construct data to store in azure blob storage.
                      const arrayBuffer = hrdcInvoiceAtchRes.data;
                      const blob = new Blob([arrayBuffer], {
                        type: "application/pdf",
                      });
                      const file = new File([blob], "hrdc_invoice.pdf", {
                        type: "application/pdf",
                      });

                      const fd = new FormData();
                      fd.append("invoice", file);
                      fd.append("xeroProcessCount", xeroProcessCount);
                      fd.append("refundType", this.formData.refundType);
                      fd.append("applicationUuid", this.formData.applicationNo);
                      fd.append("referById", this.auth.uuid);
                      fd.append(
                        "hrdcInvoiceNo",
                        invoiceDetails[0].InvoiceNumber
                      );
                      fd.append("invoiceDate", invoiceDetails[0].InvoiceDate);
                      fd.append("clientNoXero", this.HRDC_CLIENT_NO);
                      fd.append(
                        "updateToStageId",
                        this.hrdcData.stagePriority.manualInvoiceToHrdc
                      );
                      fd.append(
                        "updateToStageName",
                        this.hrdcData.stageSlugToStageName.manualInvoiceToHrdc
                      );
                      fd.append(
                        "invoiceDateScheduled",
                        this.hrdcData.stagePriority.invoiceDateScheduled
                      );

                      // Store the HRDC Invoice PDF binary data to azure blob storage & update log.
                      await this.$axios
                        .post(
                          `${
                            this.$service[this.service.key]
                          }/v1/en/console/manual_invoice/process-hrdc-flow`,
                          fd,
                          {
                            headers: {
                              Authorization: `Bearer ${this.$store.state.auth.data.token}`,
                            },
                          }
                        )
                        .then((response) => {
                          try {
                            const { status, data } = response.data;
                            if (status) {
                              xeroProcessCount++;

                              if (xeroProcessCount == LineItems.length) {
                                this.successRedirect(data);
                              }
                            }
                          } catch (err) {
                            console.log(err);
                          }
                        });
                    }
                  } else {
                    // Else, need to autorize app and get a new refresh token.
                    const xeroParams = {
                      redirectCallbackUri: this.xeroRedirectUri,
                      stateType: this.$route.query._ausk,
                    };
                    const childWindow = window.open(
                      this.requestAuthorizeApp(xeroParams)
                    );
                    var timer = setInterval(() => {
                      if (childWindow.closed) {
                        this.successRedirect(response.data);
                        clearInterval(timer);
                      }
                    }, 500);
                  }
                } catch (err) {
                  console.log(err);
                  this.alertError.push(
                    "Failed to generate HRDC Invoice due to invalid credentials & this form is submitted, please contact admin for support!"
                  );
                  return false;
                } finally {
                  this.hideLoadingDialog();
                }
              }
            );

            this.apiGetXeroRefreshToken.fetch();
          } else {
            this.hideLoadingDialog();
            this.successRedirect(response.data);
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiSubmit.fetch();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .revert-page {
  background-color: var(--app-page);
}

.dark-mode .revert-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .revert-header__info-icon {
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--amber {
  background: var(--app-warning-bg);
}

.dark-mode .hero-action-btn--amber:hover {
  background: var(--app-warning-bg);
}

.dark-mode .hero-action-btn--dark {
  background: var(--app-form-tile);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--dark:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--green {
  background: var(--app-success-bg);
}

.dark-mode .hero-action-btn--green:hover {
  background: var(--app-success-bg);
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .grant-email-card {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border);
}

.dark-mode .grant-email-card__header {
  background: var(--app-surface);
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .grant-email-card__icon {
  background: var(--app-accent-soft);
}

.dark-mode .grant-email-card__title {
  color: var(--app-text);
}

.dark-mode .ge-row__label {
  color: var(--app-text-muted);
}

.dark-mode .ge-row__value {
  color: var(--app-text);
}

.dark-mode .ge-attachment {
  background: var(--app-surface);
  border: 1px dashed var(--app-border);
}

.dark-mode .ge-attachment__icon {
  color: var(--app-text-faint);
}

.dark-mode .ge-attachment__text {
  color: var(--app-text-muted);
}

.dark-mode .ge-attachment__btn {
  background: var(--app-accent-soft);
}

.dark-mode .ge-btn--approve {
  background: var(--app-success-bg);
}

.dark-mode .ge-btn--revert {
  background: var(--app-danger-bg);
}

.dark-mode .preview-btn {
  background: var(--app-form-tile);
}

.dark-mode .preview-btn:hover {
  background: var(--app-accent-soft);
}

.dark-mode .preview-link-btn {
  background: var(--app-form-tile);
}

.dark-mode .preview-link-btn:hover {
  background: var(--app-accent-soft);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-text-muted);
}

.dark-mode .revert-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .revert-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .revert-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .revert-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .revert-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .grant-format-toggle--on {
  background: var(--app-success-bg);
}

.dark-mode .grant-format-toggle--on:hover {
  background: var(--app-success-bg);
}

.dark-mode .grant-format-toggle--off {
  background: var(--app-danger-bg);
}

.dark-mode .grant-format-toggle--off:hover {
  background: var(--app-danger-bg);
}

.dark-mode .grant-format-toggle--off .grant-format-toggle__track {
  background: var(--app-form-tile);
}

.dark-mode .grant-format-toggle__thumb {
  background: var(--app-form-tile);
}

.dark-mode .file-card {
  background: var(--app-surface);
}

.dark-mode .file-card:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .file-card__icon {
  background: var(--app-danger-bg);
}

.dark-mode .file-card__icon-wrap::after {
  border: 2px solid var(--app-border);
}

.dark-mode .file-card--has-file .file-card__icon-wrap::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='var(--app-card)'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m4.5 12.75 6 6 9-13.5'/%3E%3C/svg%3E");
}

.dark-mode .file-card--empty .file-card__icon-wrap::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='var(--app-card)'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18 18 6M6 6l12 12'/%3E%3C/svg%3E");
}

.dark-mode .file-card__name {
  color: var(--app-text);
}

.dark-mode .file-card__hint {
  color: var(--app-text-faint);
}

.dark-mode .file-card__btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .file-card__btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .status-pill--complete {
  background: var(--app-form-tile);
}

.dark-mode .status-pill--incomplete {
  background: var(--app-form-tile);
}

.dark-mode .rv-datepicker__trigger {
  border: 1px solid var(--app-field-border);
  background: var(--app-field);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__trigger--disabled {
  background: var(--app-field-disabled);
  border: 1px dashed var(--app-field-disabled-border);
}

.dark-mode .rv-datepicker__trigger--disabled:hover {
  border-color: var(--app-field-disabled-border);
}

.dark-mode .rv-datepicker__icon {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__trigger--disabled .rv-datepicker__text {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .rv-select__trigger {
  border: 1px solid var(--app-field-border);
  background: var(--app-field);
  color: var(--app-text);
}

.dark-mode .rv-select__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-select__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .rv-select__info-icon {
  color: var(--app-text-faint);
}

.dark-mode .rv-select__arrow {
  color: var(--app-text-faint);
}

.dark-mode .rv-select__dropdown {
  background: var(--app-surface);
  border: 1px solid var(--app-border);
}

.dark-mode .rv-select__dropdown::-webkit-scrollbar-thumb {
  background: var(--app-form-tile);
}

.dark-mode .rv-select__option {
  color: var(--app-text);
}

.dark-mode .rv-select__option:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .rv-select__option--selected {
  background: var(--app-accent-soft);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.revert-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  zoom: 1.1;
}

/* ============================================
   HEADER
   ============================================ */
.revert-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.revert-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px 16px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.revert-header__info {
  flex: 1;
  min-width: 0;
}

.revert-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

.revert-header__info-icon {
  color: #64748b;
  vertical-align: middle;
  margin-left: 4px;
}

.revert-header__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 16px;
}

/* ============================================
   HERO ACTION BUTTONS
   ============================================ */
.hero-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.hero-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
  transform: translateY(-1px);
}

.hero-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.hero-icon {
  width: 18px;
  height: 18px;
}

.hero-action-btn--amber {
  background: #fffbeb;
  color: #d97706;
}

.hero-action-btn--amber:hover {
  background: #fef3c7;
  color: #b45309;
}

.hero-action-btn--dark {
  background: #f1f5f9;
  color: #1e293b;
}

.hero-action-btn--dark:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.hero-action-btn--green {
  background: #dcfce7;
  color: #16a34a;
}

.hero-action-btn--green:hover {
  background: #d1fae5;
  color: #059669;
}

/* ============================================
   CARDS GRID LAYOUT
   ============================================ */
.cards-grid > * {
  min-width: 0;
  overflow: hidden;
}

.cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 960px) {
  .cards-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.cards-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ============================================
   SECTION CARDS
   ============================================ */
.section-card {
  overflow: hidden;
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header__title {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.section-body {
  overflow: hidden;
  padding: 22px;
  background: #fff;
}

.section-divider {
  border: none;
  border-top: 1px solid #eceef1;
  margin: 12px 0;
}

/* ============================================
   FORM ROWS & FIELDS
   ============================================ */
.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}

.form-label {
  flex: 0 0 180px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3239;
  line-height: 1.6;
  padding-top: 10px;
}

.form-field {
  flex: 1;
  min-width: 0;
}

.form-field--inline {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

/* ============================================
   GRANT EMAIL CARD
   ============================================ */
.grant-email-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  margin-bottom: 8px;
  overflow: hidden;
}

.grant-email-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.grant-email-card__icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0ea5e9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.grant-email-card__title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1e293b;
  flex: 1;
}

.grant-email-card__actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

.grant-email-card__body {
  padding: 16px 18px;
}

/* Grant email rows */
.ge-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.ge-row {
  display: flex;
  align-items: baseline;
  font-size: 0.82rem;
  line-height: 1.6;
}

.ge-row__label {
  flex: 0 0 165px;
  font-weight: 500;
  color: #64748b;
}

.ge-row__value {
  flex: 1;
  font-weight: 600;
  color: #1e293b;
  word-break: break-word;
}

.ge-row__value--highlight {
  color: #0ea5e9;
  font-weight: 700;
}

/* Attachment row */
.ge-attachment {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px dashed #e2e8f0;
}

.ge-attachment__icon {
  color: #94a3b8;
  flex-shrink: 0;
  display: flex;
}

.ge-attachment__text {
  flex: 1;
  font-size: 0.78rem;
  font-weight: 500;
  color: #64748b;
}

.ge-attachment__btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 6px;
  border: none;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 0.72rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s;
}

.ge-attachment__btn:hover {
  background: #0ea5e9;
  color: #fff;
}

/* Approve / Revert buttons */
.ge-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 8px;
  border: none;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.ge-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.ge-btn--approve {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.ge-btn--approve:hover:not(:disabled) {
  background: #059669;
  color: #fff;
  border-color: #059669;
}

.ge-btn--revert {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.ge-btn--revert:hover:not(:disabled) {
  background: #dc2626;
  color: #fff;
  border-color: #dc2626;
}

/* ============================================
   PREVIEW BUTTONS
   ============================================ */
.preview-btn {
  flex-shrink: 0;
  padding: 8px 16px;
  border: 1.5px solid #0ea5e9;
  border-radius: 10px;
  background: #fff;
  color: #0ea5e9;
  font-size: 0.82rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
  height: 40px;
  display: flex;
  align-items: center;
}

.preview-btn:hover {
  background: #f0f9ff;
  border-color: #0284c7;
  color: #0284c7;
}

.preview-link-btn {
  padding: 4px 12px;
  border: 1.5px solid #0ea5e9;
  border-radius: 8px;
  background: #fff;
  color: #0ea5e9;
  font-size: 0.78rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.preview-link-btn:hover {
  background: #f0f9ff;
  border-color: #0284c7;
  color: #0284c7;
}

/* ============================================
   VUETIFY INPUT OVERRIDES
   ============================================ */
.form-field >>> .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.form-field >>> .v-input__slot {
  border-radius: 10px !important;
  min-height: 40px !important;
}

.form-field >>> .v-text-field__details {
  margin-bottom: 0 !important;
  padding-top: 2px !important;
  min-height: 0 !important;
}

.form-field >>> .v-messages {
  min-height: 0 !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}

.form-field >>> .v-input--is-focused .v-input__slot {
  border-color: #56bde8 !important;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12) !important;
}

.form-field >>> .v-input__slot::before,
.form-field >>> .v-input__slot::after {
  display: none !important;
}

/* Editable fields */
.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: #fff !important;
  border: 1.5px solid #d1d5db !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: #94a3b8 !important;
}

/* Disabled fields */
.form-field >>> .v-input--is-disabled .v-input__slot {
  background: #f1f5f9 !important;
  border: 1px dashed #e2e8f0 !important;
  cursor: not-allowed !important;
}

.form-field >>> .v-input--is-disabled input,
.form-field >>> .v-input--is-disabled textarea,
.form-field >>> .v-input--is-disabled .v-select__selection {
  color: #94a3b8 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-focused) > .v-input__control > .v-input__slot::before {
  border: none !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot::after {
  border: none !important;
}

.form-field >>> .v-label {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
}

.form-field >>> .v-text-field input,
.form-field >>> .v-select__selection,
.form-field >>> .v-text-field textarea {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
}

/* Error state */
.form-field >>> .v-input--has-state .v-input__slot {
  border-color: #f87171 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled).v-input--has-state > .v-input__control > .v-input__slot {
  border-color: #ef4444 !important;
}

.form-field >>> .v-messages__message {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  color: #ef4444;
}

/* ============================================
   CONFIRM DIALOGS
   ============================================ */
.revert-confirm-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.revert-confirm-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 32px 24px;
  text-align: center;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.revert-confirm-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px;
}

.revert-confirm-card__message {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0 0 24px;
  line-height: 1.5;
}

.revert-confirm-card__actions {
  display: flex;
  gap: 12px;
}

.revert-confirm-card__btn {
  flex: 1;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.revert-confirm-card__btn--cancel {
  background: #fff;
  color: #0ea5e9;
  border: 1.5px solid #d1d5db;
}

.revert-confirm-card__btn--cancel:hover {
  background: #f8fafc;
  border-color: #0ea5e9;
}

.revert-confirm-card__btn--confirm {
  background: #56bde8;
  color: #fff;
  border: none;
}

.revert-confirm-card__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}

.revert-confirm-card__btn--danger {
  background: #ef4444;
  color: #fff;
  border: none;
}

.revert-confirm-card__btn--danger:hover {
  background: #dc2626;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

/* ============================================
   VUETIFY OVERRIDES
   ============================================ */
.v-btn {
  opacity: 1 !important;
}

.v-messages__message {
  color: #ef4444;
}

/* ============================================
   MOBILE RESPONSIVE
   ============================================ */
@media (max-width: 599px) {
  .revert-page {
    padding: 12px 8px !important;
    zoom: 1;
  }

  .revert-header {
    border-radius: 14px;
    margin-bottom: 16px;
  }

  .revert-header__top {
    flex-wrap: wrap;
    padding: 16px 16px 12px;
  }

  .back-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    margin-right: 12px;
  }

  .revert-header__title {
    font-size: 1.05rem;
    white-space: normal;
  }

  .revert-header__actions {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
  }

  .hero-action-btn {
    width: 36px;
    height: 36px;
  }

  .cards-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .cards-column {
    gap: 16px;
  }

  .section-card {
    border-radius: 14px;
  }

  .section-header {
    padding: 12px 16px;
  }

  .section-header__title {
    font-size: 0.65rem;
    letter-spacing: 1.5px;
  }

  .section-body {
    padding: 14px;
  }

  .form-row {
    flex-direction: column;
    gap: 2px;
    align-items: stretch;
  }

  .form-label {
    flex: none;
    width: 100%;
    font-size: 0.72rem;
    padding-top: 0;
    margin-bottom: 2px;
  }

  .form-field {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .form-field >>> .v-input {
    width: 100% !important;
  }

  .form-field >>> .v-input__control {
    width: 100% !important;
  }

  .form-field >>> .v-input__slot {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .form-field--inline {
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .grant-email-card__header {
    flex-wrap: wrap;
    gap: 8px;
  }

  .grant-email-card__actions {
    width: 100%;
    justify-content: flex-end;
  }

  .ge-row {
    flex-direction: column;
    gap: 2px;
  }

  .ge-row__label {
    flex: none;
  }

  .revert-confirm-card {
    padding: 24px 20px 20px;
  }

  .revert-confirm-card__title {
    font-size: 1.05rem;
  }

  .revert-page {
    overflow-x: hidden;
  }

  .section-body {
    overflow: hidden;
    word-break: break-word;
  }

  .section-card {
    max-width: 100%;
    overflow: hidden;
  }

  .cards-column {
    min-width: 0;
    max-width: 100%;
  }
}

/* Tablet breakpoint */
@media (min-width: 600px) and (max-width: 959px) {
  .revert-page {
    zoom: 1;
  }

  .revert-header__top {
    padding: 20px 20px 14px;
  }

  .revert-header__title {
    font-size: 1.15rem;
  }

  .revert-header__actions {
    flex-wrap: wrap;
    gap: 4px;
  }

  .cards-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .section-body {
    padding: 18px;
  }

  .form-label {
    flex: 0 0 160px;
  }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .revert-page {
  background-color: var(--app-page);
}

.dark-mode .revert-header {
  background: var(--app-card);
}

.dark-mode .revert-header__title {
  color: var(--app-text);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .section-card {
  background: var(--app-card);
}

.dark-mode .section-header {
  background: linear-gradient(135deg, var(--app-accent), var(--app-accent));
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .section-divider {
  border-top-color: var(--app-border);
}

.dark-mode .form-label {
  color: var(--app-text-muted);
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot:hover {
  background: var(--app-field-hover) !important;
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-focused .v-input__slot {
  border-color: var(--app-accent) !important;
  box-shadow: 0 0 0 3px var(--app-ring) !important;
}

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text);
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-field-placeholder);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-neutral-fg);
}

.dark-mode .hero-action-btn--amber {
  background: var(--app-warning-bg);
  color: var(--app-warning-fg);
}

.dark-mode .hero-action-btn--amber:hover {
  background: var(--app-warning);
  color: var(--app-warning-fg);
}

.dark-mode .hero-action-btn--dark {
  background: var(--app-border);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--dark:hover {
  background: var(--app-border-strong);
  color: var(--app-text);
}

.dark-mode .grant-email-card {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .grant-email-card__header {
  background: var(--app-card);
  border-bottom-color: var(--app-border);
}

.dark-mode .grant-email-card__icon {
  background: var(--app-accent-soft);
  color: var(--app-accent);
}

.dark-mode .grant-email-card__title {
  color: var(--app-text);
}

.dark-mode .ge-row__label {
  color: var(--app-text-faint);
}

.dark-mode .ge-row__value {
  color: var(--app-text);
}

.dark-mode .ge-row__value--highlight {
  color: var(--app-accent);
}

.dark-mode .ge-attachment {
  background: var(--app-form-tile);
  border-color: var(--app-border);
}

.dark-mode .ge-attachment__text {
  color: var(--app-text-muted);
}

.dark-mode .ge-attachment__btn {
  background: var(--app-accent-soft);
  color: var(--app-accent);
}

.dark-mode .ge-attachment__btn:hover {
  background: var(--app-accent);
  color: var(--app-accent-fg);
}

.dark-mode .ge-btn--approve {
  background: var(--app-success-bg);
  color: var(--app-success-fg);
  border-color: var(--app-success-fg);
}

.dark-mode .ge-btn--approve:hover:not(:disabled) {
  background: var(--app-success);
  color: var(--app-on-solid);
}

.dark-mode .ge-btn--revert {
  background: var(--app-danger-bg);
  color: var(--app-danger-fg);
  border-color: var(--app-danger-border);
}

.dark-mode .ge-btn--revert:hover:not(:disabled) {
  background: var(--app-danger);
  color: var(--app-on-solid);
}

.dark-mode .preview-btn {
  background: var(--app-form-tile);
  border-color: var(--app-accent);
  color: var(--app-accent-strong);
}

.dark-mode .preview-btn:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .preview-link-btn {
  background: var(--app-form-tile);
  border-color: var(--app-accent);
  color: var(--app-accent-strong);
}

.dark-mode .preview-link-btn:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .revert-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .revert-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .revert-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .revert-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  color: var(--app-accent-strong);
  border-color: var(--app-form-tile-border);
}

.dark-mode .revert-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-accent-strong);
}

.dark-mode .revert-confirm-card__btn--confirm {
  background: var(--app-accent);
}

.dark-mode .revert-confirm-card__btn--confirm:hover {
  background: var(--app-accent);
}

.dark-mode .revert-confirm-card__btn--danger {
  background: var(--app-danger);
}

.dark-mode .revert-confirm-card__btn--danger:hover {
  background: var(--app-danger);
}

/* ============================================
   GRANT FORMAT TOGGLE
   ============================================ */
.grant-input-wrap {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.grant-input-wrap .v-text-field {
  flex: 1;
}

.grant-format-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s ease;
  margin-top: 2px;
}

.grant-format-toggle--on {
  background: #f0fdf4;
  color: #16a34a;
}

.grant-format-toggle--on:hover {
  background: #dcfce7;
}

.grant-format-toggle--off {
  background: #fef2f2;
  color: #dc2626;
}

.grant-format-toggle--off:hover {
  background: #fee2e2;
}

.grant-format-toggle__track {
  width: 32px;
  height: 18px;
  border-radius: 10px;
  position: relative;
  transition: background 0.2s ease;
}

.grant-format-toggle--on .grant-format-toggle__track {
  background: #22c55e;
}

.grant-format-toggle--off .grant-format-toggle__track {
  background: #d1d5db;
}

.grant-format-toggle__thumb {
  position: absolute;
  top: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  transition: left 0.2s ease;
}

.grant-format-toggle--on .grant-format-toggle__thumb {
  left: 16px;
}

.grant-format-toggle--off .grant-format-toggle__thumb {
  left: 2px;
}

.grant-format-toggle__label {
  letter-spacing: 0.3px;
  display: inline-block;
  width: 48px;
  text-align: left;
}

/* Dark mode */
.dark-mode .grant-format-toggle--on {
  background: var(--app-success-bg);
  color: var(--app-success-fg);
}

.dark-mode .grant-format-toggle--on:hover {
  background: var(--app-success-bg);
}

.dark-mode .grant-format-toggle--off {
  background: var(--app-danger-bg);
  color: var(--app-danger-fg);
}

.dark-mode .grant-format-toggle--off:hover {
  background: var(--app-danger-bg);
}

.dark-mode .grant-format-toggle--off .grant-format-toggle__track {
  background: var(--app-border-strong);
}

/* ============================================
   FILE CARD
   ============================================ */
.file-card {
  overflow: hidden;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  background: #f8fafc;
  transition: background 0.15s;
}

.file-card:hover {
  background: #f1f5f9;
}

.file-card__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #fef2f2;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.file-card__icon-wrap {
  position: relative;
  flex-shrink: 0;
}

.file-card__icon-wrap::after {
  content: '';
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #f8fafc;
  background-size: 10px;
  background-position: center;
  background-repeat: no-repeat;
}

.file-card--has-file .file-card__icon-wrap::after {
  background-color: #22c55e;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m4.5 12.75 6 6 9-13.5'/%3E%3C/svg%3E");
}

.file-card--empty .file-card__icon-wrap::after {
  background-color: #ef4444;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18 18 6M6 6l12 12'/%3E%3C/svg%3E");
}

.file-card__svg {
  width: 20px;
  height: 20px;
}

.file-card__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-card__name {
  max-width: 100%;
  font-size: 0.82rem;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-card__hint {
  font-size: 0.7rem;
  color: #94a3b8;
}

.file-card__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.file-card__btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.file-card__btn:hover {
  background: #e2e8f0;
  color: #334155;
}

.file-card__btn-icon {
  width: 16px;
  height: 16px;
}

.file-card__hidden {
  display: none;
}

/* Dark mode */
.dark-mode .file-card {
  overflow: hidden;
  min-width: 0;
  background: var(--app-form-tile);
}

.dark-mode .file-card:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .file-card__icon {
  background: var(--app-danger-bg);
  color: var(--app-danger-fg);
}

.dark-mode .file-card__name {
  max-width: 100%;
  color: var(--app-neutral-fg);
}

.dark-mode .file-card__hint {
  color: var(--app-text-faint);
}

.dark-mode .file-card__btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .file-card__btn:hover {
  background: var(--app-border);
  color: var(--app-neutral-fg);
}

.dark-mode .file-card__icon-wrap::after {
  border-color: var(--app-card);
}

/* ============================================
   STATUS PILL (section header)
   ============================================ */
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-left: auto;
}

.status-pill__icon {
  width: 12px;
  height: 12px;
}

.status-pill--complete {
  background: #fff;
  color: #16a34a;
}

.status-pill--incomplete {
  background: #fff;
  color: #dc2626;
}

/* ============================================
   DATEPICKER TRIGGER
   ============================================ */
.rv-datepicker__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
}

.rv-datepicker__trigger:hover {
  border-color: #94a3b8;
}

.rv-datepicker__trigger--disabled {
  background: #f1f5f9;
  border: 1px dashed #e2e8f0;
  cursor: not-allowed;
}

.rv-datepicker__trigger--disabled:hover {
  border-color: #e2e8f0;
}

.rv-datepicker__trigger--error {
  border-color: #ef4444;
}

.rv-datepicker__icon {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  flex-shrink: 0;
}

.rv-datepicker__text {
  color: #1e293b;
  font-weight: 600;
}

.rv-datepicker__trigger--disabled .rv-datepicker__text {
  color: #94a3b8;
}

.rv-datepicker__placeholder {
  color: #94a3b8;
}

/* Dark mode */
.dark-mode .rv-datepicker__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__trigger--disabled {
  background: var(--app-field-disabled);
  border-color: var(--app-field-disabled-border);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__trigger--disabled .rv-datepicker__text {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

/* Hide number input spin buttons */
.form-field >>> input[type="number"]::-webkit-outer-spin-button,
.form-field >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.form-field >>> input[type="number"] {
  -moz-appearance: textbox;
}

/* ============================================
   CUSTOM SELECT DROPDOWN
   ============================================ */
.rv-select {
  position: relative;
}

.rv-select__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #1e293b;
}

.rv-select__trigger:hover {
  border-color: #94a3b8;
}

.rv-select__trigger--open {
  border-color: #56bde8;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12);
}

.rv-select__trigger--error {
  border-color: #ef4444;
}

.rv-select__value {
  flex: 1;
  min-width: 0;
}

.rv-select__placeholder {
  color: #94a3b8;
}

.rv-select__right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.rv-select__info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.rv-select__info-icon {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  transition: color 0.15s;
}

.rv-select__info:hover .rv-select__info-icon {
  color: #0ea5e9;
}

.rv-select__arrow {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  flex-shrink: 0;
  margin-left: 4px;
  transition: transform 0.2s ease;
}

.rv-select__arrow--open {
  transform: rotate(180deg);
}

.rv-select__dropdown {
  margin-top: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.rv-select__dropdown::-webkit-scrollbar {
  width: 5px;
}

.rv-select__dropdown::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.rv-select__option {
  padding: 9px 12px;
  border-radius: 7px;
  font-size: 0.85rem;
  color: #334155;
  cursor: pointer;
  transition: background 0.12s;
}

.rv-select__option:hover {
  background: #fff;
}

.rv-select__option--selected {
  background: #e0f2fe;
  color: #0369a1;
  font-weight: 600;
}

.rv-select__option--selected:hover {
  background: #bae6fd;
}

.rv-select__error {
  margin-top: 6px;
  font-size: 0.8rem;
  color: #ef4444;
}

.rv-error-list {
  margin: 0;
  padding-left: 16px;
  list-style: disc;
}

.rv-error-list li {
  margin-bottom: 2px;
}

/* Dark mode */
.dark-mode .rv-select__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
  color: var(--app-text);
}

.dark-mode .rv-select__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-select__trigger--open {
  border-color: var(--app-accent);
  box-shadow: 0 0 0 3px var(--app-ring);
}

.dark-mode .rv-select__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .rv-select__dropdown {
  background: var(--app-form-tile);
  border-color: var(--app-border);
}

.dark-mode .rv-select__option {
  color: var(--app-neutral-fg);
}

.dark-mode .rv-select__option:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .rv-select__option--selected {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
}

/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text) !important;
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .v-picker__body {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header__value button {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.dark-mode .v-date-picker-header .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table thead th {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-date-picker-table .v-btn {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-table .v-btn:hover {
  background: var(--app-accent-soft) !important;
}

.dark-mode .v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-picker__actions {
  background: var(--app-form-tile) !important;
  border-top: 1px solid var(--app-border) !important;
}

/* >>> end auto-dark <<< */

/* ============================================
   VUETIFY DATE PICKER OVERRIDE (unscoped)
   ============================================ */
.v-picker {
  border-radius: 14px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  border: none !important;
  overflow: hidden;
  font-family: 'Lato', sans-serif !important;
}

.v-picker .v-picker__body {
  border: none !important;
}

/* The unscoped `.v-menu__content …` block that used to sit here is gone.
   It was global — unscoped CSS is injected once and never removed, so a rule
   written for THIS page's dropdown repainted every menu in the app (with
   !important, and with hard-coded light hex) for the rest of the session. That
   is what made the same v-select look different depending on which page you had
   visited. Menus are defined ONCE, in tokens, in src/plugins/theme-glass.css §3
   — panel, list, item radius, hover, active, typography and the state overlay.
   A page that genuinely needs its own menu styling should give that v-menu a
   `content-class` and key off it, the way .bdt-menu and .tb-view-menu do. */

.v-picker__body {
  background: #fff !important;
}

/* Month/year header */
.v-date-picker-header {
  padding: 12px 16px 8px !important;
  background: #fff !important;
}

.v-date-picker-header__value button {
  font-family: 'Lato', sans-serif !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  color: #1e293b !important;
}

.v-date-picker-header .v-btn {
  color: #64748b !important;
}

.v-date-picker-header .v-btn:hover {
  background: #f1f5f9 !important;
}

/* Weekday headers */
.v-date-picker-table thead th {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  color: #94a3b8 !important;
  padding: 8px 0 !important;
}

/* Day buttons */
.v-date-picker-table .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.v-date-picker-table .v-btn:hover {
  background: #f0f9ff !important;
}

.v-date-picker-table .v-btn--active {
  background: #0ea5e9 !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.v-date-picker-table .v-btn--active:hover {
  background: #0284c7 !important;
}

/* Today indicator */
.v-date-picker-table .v-btn--outlined {
  border-color: #0ea5e9 !important;
  color: #0ea5e9 !important;
}

/* Disabled days */
.v-date-picker-table .v-btn--disabled {
  color: #cbd5e1 !important;
}

/* Action buttons (Cancel/OK) */
.v-picker__actions {
  padding: 8px 16px 14px !important;
  background: #fff !important;
  border-top: 1px solid #f1f5f9 !important;
}

.v-picker__actions .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.82rem !important;
  letter-spacing: 0.3px !important;
  text-transform: none !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
}

/* Month picker (when clicking month/year) */
.v-date-picker-years li,
.v-date-picker-months .v-btn {
  font-family: 'Lato', sans-serif !important;
}

/* Dark mode */
.dark-mode .v-picker {
  border-color: var(--app-border) !important;
  box-shadow: 0 8px 30px var(--app-shadow-mid) !important;
}

.dark-mode .v-picker__body {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header {
  background: var(--app-card) !important;
}

.dark-mode .v-date-picker-header__value button {
  color: var(--app-text) !important;
}

.dark-mode .v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.dark-mode .v-date-picker-header .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table thead th {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-date-picker-table .v-btn {
  color: var(--app-neutral-fg) !important;
}

.dark-mode .v-date-picker-table .v-btn:hover {
  background: var(--app-form-tile-hover) !important;
}

.dark-mode .v-date-picker-table .v-btn--active {
  background: var(--app-accent) !important;
  color: var(--app-accent-fg) !important;
}

.dark-mode .v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.dark-mode .v-picker__actions {
  background: var(--app-form-tile) !important;
  border-top-color: var(--app-border) !important;
}
</style>
